import { DTFSettings } from './settings';

export interface PriceResult {
	totalCm: number;
	/** prix avant application du minimum */
	brut: number;
	/** prix facturé (minimum commande appliqué) */
	total: number;
	minApplied: boolean;
	/** prix hors taxe */
	ht: number;
	/** montant de TVA */
	tva: number;
	/** total TVA comprise */
	ttcTotal: number;
	devise: string;
	ttc: boolean;
}

/** facteur colle : anti-sublimation = +50 % (supplément de la grille dtf_prix) */
export const GLUE_FACTOR = { base: 1, anti: 1.5 } as const;

export function computePrice(totalCm: number, s: DTFSettings, glue: 'base' | 'anti' | null = null): PriceResult {
	const f = glue === 'anti' ? GLUE_FACTOR.anti : 1;
	const brut = Math.round(totalCm * s.prixCmLineaire * f * 100) / 100;
	const minCmd = Math.round(s.minCommande * f * 100) / 100;
	let total = brut;
	let minApplied = false;
	if (totalCm > 0 && brut < minCmd) {
		total = minCmd;
		minApplied = true;
	}
	if (totalCm <= 0) total = 0;
	const tva = s.prixTtc
		? Math.round((total - total / (1 + s.tvaPct / 100)) * 100) / 100
		: Math.round(total * (s.tvaPct / 100) * 100) / 100;
	const ht = s.prixTtc ? Math.round((total - tva) * 100) / 100 : total;
	const ttcTotal = s.prixTtc ? total : Math.round((total + tva) * 100) / 100;
	return { totalCm, brut, total, minApplied, ht, tva, ttcTotal, devise: s.devise, ttc: s.prixTtc };
}

export function fmtMoney(v: number, devise: string): string {
	return `${v.toFixed(2)} ${devise}`;
}
